import * as React from 'react';
import { Tooltip } from '@grandvisionhq/common';
import { RadioButtons, Form } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

var OpticianType;
(function(OpticianType) {
    OpticianType["Internal"] = 'internal';
    OpticianType["External"] = 'external';
})(OpticianType || (OpticianType = {}));
const Optician = ({ selectedOpticianType , onOpticianTypeChange , onOpticianFormChange , opticianFormState , opticianForm ,  })=>{
    const { getLabel  } = useIntl();
    const radioOptions = React.useMemo(()=>[
            {
                value: OpticianType.Internal,
                label: getLabel('products.contactLens.info.optician.internal')
            },
            {
                value: OpticianType.External,
                label: getLabel('products.contactLens.info.optician.external')
            }, 
        ]
    , [
        getLabel
    ]);
    const handleRadiosChange = React.useCallback(({ value  })=>{
        onOpticianTypeChange(value);
    }, [
        onOpticianTypeChange
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "prescription-info-optician"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "prescription-info-optician__label"
    }, getLabel('products.contactLens.info.optician.label'), /*#__PURE__*/ React.createElement(Tooltip, {
        message: getLabel('products.contactLens.info.optician.hint'),
        id: "validation-optician-tooltip"
    })), /*#__PURE__*/ React.createElement(RadioButtons, {
        formName: "optician-type",
        scope: "opticianType",
        alignment: "vertical",
        onChange: handleRadiosChange,
        initialValue: selectedOpticianType,
        items: radioOptions
    }), selectedOpticianType === OpticianType.External && /*#__PURE__*/ React.createElement("div", {
        className: "prescription-info-optician__store-form"
    }, /*#__PURE__*/ React.createElement(Form, {
        name: "opticianForm",
        "data-t": "optician-form",
        className: "prescription-info-optician__form",
        initialFormState: opticianFormState,
        onChange: onOpticianFormChange
    }, opticianForm)));
};

export { Optician, OpticianType };
//# sourceMappingURL=Optician.js.map
